module.exports = __webpack_public_path__ + "static/img/BQ-SA.91591c34.svg";